import { render, staticRenderFns } from "./TabSwitcher.vue?vue&type=template&id=520adb3a&scoped=true&"
import script from "./TabSwitcher.vue?vue&type=script&lang=js&"
export * from "./TabSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./TabSwitcher.vue?vue&type=style&index=0&id=520adb3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520adb3a",
  null
  
)

export default component.exports